import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions
} from '../../fundamentals/text-styles/constants'
import {
  highlightedVariant,
  minimalVariant,
  strongVariant,
  subtleVariant
} from './styled-components'

const badgeSizeOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  'EXTRA-LARGE': 'extra-large'
}

const badgeStyleOptions = {
  [badgeSizeOptions.SMALL]: {
    iconSize: '10px',
    padding: '4px 4px 4px 4px',
    gap: '2px',
    maxHeight: '18px',
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XS']]
  },
  [badgeSizeOptions.MEDIUM]: {
    iconSize: '12px',
    padding: '4px 8px 4px 8px',
    gap: '4px',
    maxHeight: '24px',
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]
  },
  [badgeSizeOptions.LARGE]: {
    iconSize: '14px',
    padding: '4px 12px 4px 12px',
    gap: '6px',
    maxHeight: '28px',
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]
  },
  [badgeSizeOptions['EXTRA-LARGE']]: {
    iconSize: '16px',
    padding: '4px 16px 4px 16px',
    gap: '8px',
    maxHeight: '32px',
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]
  }
}

const badgesVariantOptions = {
  MINIMAL: 'minimal',
  SUBTLE: 'subtle',
  STRONG: 'strong',
  HIGHLIGHTED: 'highlighted'
}

const badgeComponentVariantOptions = {
  [badgesVariantOptions.MINIMAL]: minimalVariant,
  [badgesVariantOptions.SUBTLE]: subtleVariant,
  [badgesVariantOptions.STRONG]: strongVariant,
  [badgesVariantOptions.HIGHLIGHTED]: highlightedVariant
}

const badgeColorOptions = {
  YELLOW: 'yellow',
  ORANGE: 'orange',
  RED: 'red',
  PINK: 'pink',
  PURPLE: 'purple',
  VIOLET: 'violet',
  DARKBLUE: 'darkblue',
  BLUE: 'blue',
  TURQUOISE: 'turquoise',
  PETROL: 'petrol',
  DARKGREEN: 'darkgreen',
  GREEN: 'green',
  OCHRE: 'ochre',
  MUESLI: 'muesli',
  DARKBROWN: 'darkbrown',
  DOCU_TOOLS_DARK: 'docu-tools-dark',
  DOCU_TOOLS_ORANGE: 'docu-tools-orange',
  DISABLED: 'disabled'
}

export {
  badgeSizeOptions,
  badgeStyleOptions,
  badgesVariantOptions,
  badgeComponentVariantOptions,
  badgeColorOptions
}
